module.exports = __webpack_public_path__ + "img/img_theme05.1ff8b361.svg";